import {ApplicationContract, AppState, Error} from "./model";

export const selectApplication = (state: AppState) => state.application ?? {};
export const selectApplicationContracts = (state: AppState) => state.applicationContracts ?? [] as ApplicationContract[];
export const selectAddressAutocomplete = (state: AppState) => state.addressAutocomplete ?? [];
export const selectErrors = (state: AppState) => state.errors ?? [] as Error[];
export const selectFederalClassifications = (state: AppState) => state.federalClassifications ?? [];
export const selectRegions = (state: AppState) => state.regions ?? [];
export const selectTrades = (state: AppState) => state.trades ?? [];
export const selectUser = (state: AppState) => state.session?.user ?? {};
